export default ({ text, color }) => ({
    content: {
        height: 50,
        marginTop: -8,
    },
    sliderStyle: {
        width: 224,
        display: 'inline-block',
        height: 37,
    },
    sliderStyle2: {
        marginTop: 0,
        marginBottom: 0,
    },
    title: {
        ...text.text_md,
        marginRight: 16,
        width: '150px',
        display: 'inline-block',
        paddingTop: '15px',
        paddingBottom: '13px',
        boxSizing: 'border-box',
    },
    textPercent: {
        ...text.text_md,
        display: 'inline-block',
        marginLeft: 16,
    },
    fieldContainer: {
        height: '44px',
        margin: '0 20px',
    },
});
